import { jsx as _jsx } from "react/jsx-runtime";
import classes from './index.module.scss';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
const ChatBoxContent = ({ children }) => {
    console.warn('ChatBoxContent is deprecated, use @ucc-messaging/inbox-common-ui instead');
    return _jsx("section", Object.assign({ className: classes.content }, { children: children }), void 0);
};
export default ChatBoxContent;
//# sourceMappingURL=index.js.map